// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__1X6Ey","content":"Page_content__bZ9q8","scrollingDisabled":"Page_scrollingDisabled__1yP_t"};